const eventData = [
  {
    date: new Date(2023, 5, 10), // 7 means August
    name: "ZipDate",
    description:
      "A modern full stack dating website which makes connections on common history. Check out Github repo or Use email karen.smith@example.com and password Password1234$ if you want to quick login. This was a really big project, had to built from scratch as messaging, profiles, liking , disliking and post that delinking had to be done. ",
    link: "https://zipdate-22ce74903b8d.herokuapp.com/",
  },
  {
    date: new Date(2023, 11, 25), // 7 means August
    name: "Kid Math",
    description:
      "Web Application for Kids to learn math more interactively, built as a havoc case study under CS546 - Human Computer Interaction. Built on vercel using vite + react + tailwind + using browser as a db.",
    link: "https://web-beryl-one.vercel.app/",
  },
  {
    date: new Date(2023, 7, 25), // 7 means August
    name: "Mihir",
    description: "This Website",
    link: "/",
  },
    {
    date: new Date(2022, 11, 25), // 7 means August
    name: "Bus Scheduling Simulations For Operating Systems",
    description: "Bus Simulations Process Scheduling using core java for operating systems",
    link: "https://github.com/mixh/OS_Bus_Simulations",
  },
  {
    date: new Date(2023, 5, 26), // 7 means August
    name: "Infinite Dogs",
    description: "Vanilla JS to see Dog images on scroll",
    link: "https://master--spiffy-kitsune-039340.netlify.app/",
  },
  {
    date: new Date(2022, 6, 1), // 7 means August
    name: "Image Segmentation Research on Detection of Cardiovascular Pneumonia",
    description:
      "Research Thesis on Analysis of pneumonia scans worked with resnet led implementation of faster rcnn using tensorflow",
    link: "https://drive.google.com/file/d/1mXPN0kCipsnRbscZ-AQsIxEQgjRt3UZn/view?usp=sharing",
  },
  {
    date: new Date(2021, 5, 26), // 7 means August
    name: "Graph Based Network Analysis of FMRI",
    description:
      "Employed graph-theory based complex network analysis to investigate the topological properties of the brain networks",
    link: "https://drive.google.com/file/d/1mLN8Qpz77DxFxtYBrFGB4H3VGqDtT3hn/view?usp=sharing",
  },
  {
    date: new Date(2021, 3, 26), // 7 means August
    name: "KNN Case Study on Diabetes Evaluation ",
    description:
      "Part of my bachelors Data Mining and Warehouse coursework research",
    link: "https://drive.google.com/file/d/1Y3Yj_GaE_8oAn8Sxmmi_j0fSXAtK9O04/view?usp=sharing",
  },
  {
    date: new Date(2020, 7, 17), // 7 means August
    name: "Database Management System",
    description:
      "Database Management System using PHP MySql jQuery in xampp environment",
    link: "https://github.com/mixh/DatabaseManagementSystem",
  },
  // Add more event objects as needed
];

export default eventData;
